module.exports = __webpack_public_path__ + "assets/img/site_20w_report_witnesses_l1.1695f58e.png";